import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
const ErrorPage = React.lazy(() => import("../components/error-page"));
const TareasProgramadas = React.lazy(
  () => import("../screean/task/tareasProgramadas")
);
export function tareasProgramadas() {
  return (
    <Route
      path="/tareas-programadas"
      element={
        <LazySuspense>
          <ProtectedRoute>
            <LazySuspense>
              <TareasProgramadas />
            </LazySuspense>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
